import { render } from "./ImportExpenses.vue?vue&type=template&id=f803b2c0"
import script from "./ImportExpenses.vue?vue&type=script&lang=js"
export * from "./ImportExpenses.vue?vue&type=script&lang=js"

import "./ImportExpenses.vue?vue&type=style&index=0&id=f803b2c0&lang=css"
script.render = render

export default script